<!-- //
数据服务-API接口详情
@auth xuyd
@date 2024-05-03
//-->
<template>
  <page-layout layout="C">
    <div class="layout-function flex-row flex-valign-center flex-halign-between" style="">
      <div class="flex-row flex-valign-center">
        <span>{{ form.apiComment }}（{{ form.apiName }}）</span>
        <el-divider direction="vertical"/>
        <dict-tag v-if="form.resolve"
                  :options="{type: 'tag'}"
                  dictType="ONLINE_STATUS"
                  :value="form.onlineStatus"/>
        <dict-tag v-else
                  :options="{type: 'tag'}"
                  dictType="API_STATUS"
                  :value="form.apiStatus"/>
      </div>
      <div class="flex-row flex-valign-center">
        <span v-if="form.apiVersion">版本：V{{ form.apiVersion }}</span>
        <span v-else>未定版</span>
        <el-divider direction="vertical"/>
        <el-button size="small" @click="handleCancel">关 闭</el-button>
      </div>
    </div>
    <div class="layout-result" style="height: 100%;margin-top: 5px;">
      <DetailBasic :form-data="form" />
    </div>
  </page-layout>
</template>

<script>

import ApiDesignApi from '@/api/datasvc/apiDesign.api.js';
import DetailBasic from './detail-basic';

export default {
  name: 'ViewApiDesignDetail',
  components: {DetailBasic},
  dictTypes: [
    {dictType: 'API_STATUS', dataType: Number},
    {dictType: 'ONLINE_STATUS', dataType: Number},
  ],
  data() {
    return {
      loading: false,
      form: {
        id: null,
        apiName: null,
        apiNum: null,
        apiDesc: null,
        apiStatus: null,
        apiVersion: null,
        designUser: null,
        designTime: null,
        reqParamList: [],
        respParamList: [],
      },
    }
  },
  created() {
    this.form.id = this.$route.query.id;
    this.getApiInfo();
  },
  computed: {
    editMode() {
      return !!this.form.id;
    }
  },
  methods: {
    getApiInfo() {
      if (this.editMode) {
        ApiDesignApi.getInfo(this.form.id).then(resp => {
          this.form = resp.data;
        });
      }
    },
    handleSave() {
      ApiDesignApi.saveInfo(this.form).then(resp => {
        this.form.id = resp.data;
        this.$modal.msgSuccess("保存成功");
      });
    },
    handleCancel() {
      window.close();
    }
  }
}
</script>

<style lang="less" scoped>
</style>
